






























































































































































































































































import Vue from 'vue'
import Modal from '@/pmd/components/common/Modal.vue'
import {
  TwilioAccount,
  Company,
  Location,
  AuthUser,
  PrivateUser,
  User as FirestoreUser
} from '@/models'
import { mapState } from 'vuex'
import { CompanyState, UserState } from '@/store/state_models'
import { UserSource, UserSourceChannel } from '@/models/user'
import moment from 'moment'
import User from '../../../models/api/User'

export interface EmailIds {
  val: string
  valid: boolean
  exists: boolean
}

export default Vue.extend({
  props: ['modalShow', 'currentLocationId'],
  components: {
    Modal,
  },
  data() {
    return {
      popupWidth: 500,
      loader: false,
      location: {} as Location,
      emailId: '',
      emailIds: [] as EmailIds[],
      placeholder: 'name@example.com',
      sentInviteSuccess: false,
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      creating: false,
      hasWebsite: false,
      website: '',
      twilioAccount: {} as TwilioAccount,
      meetingLocation: undefined,
      timezone: undefined,
      openHours: [],
      userCalendar: '' as string,
      userTwilio: '' as undefined | string,
      existingLocations: {} as { [key: string]: string },
      incomingPhoneNumbers: [] as Array<{ [key: string]: any }>,
      locations: [] as Location[],
      passwordText: '',
      autofillSignature: false,
      replySignature: false,
      tinymcehtml: '' as string,
      isZoomAdded: '' as string,
      userPermissions: {
        campaigns_enabled: true,
        campaigns_read_only: false,
        workflows_enabled: true,
        workflows_read_only: false,
        contacts_enabled: true,
        triggers_enabled: true,
        opportunities_enabled: true,
        settings_enabled: true,
        tags_enabled: true,
        lead_value_enabled: true,
        dashboard_stats_enabled: true,
        bulk_requests_enabled: true,
        appointments_enabled: true,
        reviews_enabled: true,
        online_listings_enabled: true,
        phone_call_enabled: true,
        conversations_enabled: true,
        assigned_data_only: false,
        funnels_enabled: true,
        websites_enabled: true,
        marketing_enabled: true,
        adwords_reporting_enabled: true,
        facebook_ads_reporting_enabled: true,
        attributions_reporting_enabled: true,
        membership_enabled: true,
        bot_service: false,
        agent_reporting_enabled: true,
      },
    }
  },
  async mounted() {
    this.location = new Location(
      await this.$store.dispatch(
        'locations/getCurrentLocation',
        this.currentLocationId
      )
    )
  },
  computed: {
    errorIdsCount() {
      return this.emailIds.filter(id => !id.valid).length
    },
    existsIdsCount() {
      return this.emailIds.filter(id => id.exists).length
    },
    correctIdsCount() {
      return this.emailIds.filter(id => id.valid && !id.exists).length
    },
    ...mapState('user', {
      user: (s: UserState) => {
        return s.user ?  User.getUserFromFirestoreModel(new FirestoreUser(s.user)) : undefined
      },
    }),
    ...mapState('company', {
      company: (s: CompanyState) => {
        return s.company ? new Company(s.company) : undefined
      },
    }),
  },
  methods: {
    validateEmailId(email: string) {
      const emailRegEx = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/
      return emailRegEx.test(email)
    },
    closeModal() {
      this.sentInviteSuccess = false
      this.$root.$emit('close-modal')
    },
    async addEmail(event) {
      event.preventDefault()
      const val = this.emailId.trim()
      this.emailId = ''
      const exists = this.emailIds.find(
        o => o.val.toLowerCase() === val.toLowerCase()
      )
      if (val.length > 0 && !exists) {
        let valid = this.validateEmailId(val)
        let exists = false
        if (await this.emailExists(val)) {
          exists = true
        }
        this.emailIds.push({ val, valid, exists })
        this.placeholder = ''
      }
    },
    removeTag(index) {
      this.emailIds.splice(index, 1)
    },
    removeLastEmail(event) {
      if (this.emailId.length === 0) {
        this.removeTag(this.emailIds.length - 1)
      }
    },
    removeErrorIds() {
      const emailIds = this.emailIds.filter(email => email.valid)
      this.emailIds = emailIds
    },
    removeExistsIds() {
      const emailIds = this.emailIds.filter(email => !email.exists)
      this.emailIds = emailIds
    },
    focusInput() {
      this.$refs.emailInput.focus()
      this.sentInviteSuccess = false
    },
    async sendInvite() {
      this.loader = true
      try {
        for (const user of this.emailIds) {
          if (user.valid && !user.exists) await this.createUser(user.val)
        }
        this.emailIds = []
        this.placeholder = 'name@example.com'
        this.sentInviteSuccess = true
      } catch (e) {
        console.log(e)
      }
      this.loader = false
    },
    async createUser(email: string) {
      try {
        const locationId = this.currentLocationId
        const user = new User()

        user.role = User.ROLE_USER
        user.companyId = this.location.companyId
        user.type = User.TYPE_ACCOUNT
        user.permissions = this.userPermissions
        user.firstName = this.firstName
        user.lastName = this.lastName
        user.email = email.trim()
        user.phone = this.phone
        user.extension = ''
        user.isPasswordPending = true
        user.locations = {
          [locationId]: ''
        }
        user.userEmailSignature = {
          [locationId]: {
          signature: this.tinymcehtml,
          autofill: this.autofillSignature,
          reply_signature: this.replySignature,
          }
        }

        const defaultOpenHours = []

        for (var i = 0; i < 7; i++) {
          defaultOpenHours.push({
            days_of_the_week: [i],
            hours: [
              {
                open_hour: 0,
                open_minute: 0,
                close_hour: 0,
                close_minute: 0,
              },
            ],
          })
        }

        user.locationWiseMeetingLocation = {
          [locationId]: this.meetingLocation || ''
        }
        user.locationWiseZoomAdded = {
          [locationId] : this.isZoomAdded || ''
        }
        user.locationWiseTimezone = {
          [locationId] : this.timezone || ''
        }
        user.locationWiseOpenHours = {
          [locationId] : defaultOpenHours
        }
        user.userCalendar = {
          [locationId] : this.userCalendar
        }
        user.lastLoginTime = moment()

        user.setCreatedByAndOrLastUpdatedBy(true, UserSource.LaunchPad, UserSourceChannel.WEB_APP)

        const admin = await user.save()

        await this.sendMagicLink(admin.id)
      } catch (err) {
        console.log(err)
      }
    },
    async sendMagicLink(userId: string) {
      try {
        await this.$http.post('/launchpad/schedule', {
          locationId: this.currentLocationId,
          types: ['magic_link'],
          userId,
          senderId: this.user.id,
        })
      } catch (err) {
        console.log(err)
      }
    },
    async emailExists(email: string) {
      try {
        const auth: AuthUser = new AuthUser(
          await this.$root.$store.dispatch('auth/get')
        )
        const response = await this.$http.post('/exists', {
          email,
          companyId: auth.companyId,
        })
        return response.status === 200 ? false : true
      } catch (err) {
        return true
      }
    },
  },
})
